import { setAnalyticsCollectionEnabled } from "firebase/analytics";
import { analytics } from "../firebase";
import { getCookiePreferences } from "./cookiePreferences";

export const ANALYTICS_SYNC_EVENT = "cg-analytics-sync";

export function isPerformanceTrackingAllowed() {
  return getCookiePreferences().performance;
}

export function syncAnalytics() {
  const allowed = isPerformanceTrackingAllowed();

  if (analytics) {
    setAnalyticsCollectionEnabled(analytics, allowed);
  }

  window.dispatchEvent(new CustomEvent(ANALYTICS_SYNC_EVENT, { detail: { allowed } }));
}
